module.exports = __webpack_public_path__ + "img/s00134.56f16450.jpg";